// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ToggleModal_overlay__3aiPU","backdrop":"ToggleModal_backdrop__1jd9m"};